<template>

    <v-card
		color="brightBackground"
		flat
		tile
        height="100%"
	>

        <v-container fluid style="max-width: 1000px;">

            <!-- Form -->
            <v-form ref="newClientForm">

            <v-row>

                <v-col
                    align="center"
                    justify="center"
                >
                    <v-row no-gutters>
                        <v-subheader class="display-1 font-weight-bold pl-3 mt-5 ml-0 mb-3 pb-5 grey--text text--darken-3">Create client</v-subheader>
                    </v-row>

                    <v-row no-gutters>

                        <v-col cols="6" xs="12" sm="12" md="12" xl="12" class="px-3">
                            <v-text-field
                                label="Client name"
                                v-model="clientData.name"
                                :rules="agile.fieldRules.nameRules"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                    </v-row>


                    <v-row no-gutters>

                        <v-col cols="6" xs="12" sm="12" md="8" xl="8" class="px-3">
                            <v-text-field
                                label="Client safe name (for use with variables, urls etc.)"
                                v-model="clientData.variable"
                                :rules="agile.fieldRules.variableRules"
                                outlined
                                dense
                                
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" xs="12" sm="12" md="4" xl="4" class="px-3">
                            <v-text-field
                                label="Client prefix name"
                                v-model="clientData.prefix"
                                :rules="agile.fieldRules.prefixRules"
                                outlined
                                dense
                                
                            ></v-text-field>
                        </v-col>

                        
                    </v-row>


                    <v-row no-gutters>

                        <v-col align="right">
                            <v-btn color="iconTextColor" class="mr-3" small text router to="/admin/clients">
                                <v-icon medium class="pr-1">mdi-cancel</v-icon>
                                Cancel
                            </v-btn>
                            <v-btn color="iconTextColor" class="mr-3" small text @click="createClient">
                                <v-icon medium class="pr-1">mdi-check-bold</v-icon>
                                Create client
                            </v-btn>
                        </v-col>
                        
                    </v-row>

                </v-col>

            </v-row>

            </v-form>

        </v-container>
    </v-card>

</template>




<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';


export default
{
    name: 'NewClient',

    // ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({

        clientData:
        {
            name: '',
            variable: '',
            prefix: '',
        },

        
	}),

    computed:
	{
        // Get agile for the field rules (for validating)
        agile()
        {
            return agile;
        },
    },


    // ----------------------------------------------------
    //
    //  VUE: Create and Mount
    //
    // ----------------------------------------------------
    
    created()
    {
		
    },

	mounted()
	{
        
	},


	// --------------------------------------------------------------------
    //
    //	VUE: Methods
    //
	// --------------------------------------------------------------------
    
	methods:
	{

        createClient()
        {
            if (this.validate())
            {
                this.$root.ai_app.showProgressWheel = true;

                // ----------------------------------
                //	Create client in Firebase
                // ----------------------------------

                fb.db.collection('clients').add(
				{
                    name: this.clientData.name,
                    variable: this.clientData.variable,
                    prefix: this.clientData.prefix.toLowerCase(),
                    key: this.clientData.prefix.toLowerCase(),
                    accessMap:
                    {
                        master: this.clientData.prefix,
                        group: '*',
                        project: '*',
                    }
				})
                .then(() =>
                {
                    this.$root.ai_app.snackbarText = 'Client created';
                    this.$root.ai_app.snackbarTimeout = 3000;
                    this.$root.ai_app.snackbar = true;
                    this.$root.ai_app.showProgressWheel = false;
                    this.$router.push('/admin/clients');

                })
                .catch((error) =>
                {
                    this.$root.ai_app.showProgressWheel = false;
                    this.$root.$alert("Error", error.message);
                });

            }
            
            //console.log(this.clientData);
        },


        // ----------------------------------
        //	Form validation
        // ----------------------------------
        
        validate()
        {
            this.clientData.prefix = this.clientData.prefix.toLowerCase();
            return this.$refs.newClientForm.validate();
        },

        resetValidation()
        {
            this.$refs.newClientForm.resetValidation();
        },


	},



	// ----------------------------------
	//	VUE: Components
	// ----------------------------------

    components:
    {
        
    }

}
</script>